import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {ClienteF} from '../../../../interfaces/facturacion.interface'
import {State} from '../../../../reducers'
import {bindActionCreators} from 'redux'
import {actionFacturacionCliente, actionFacturacionProducto, actionGeneral, actionsClienteReceptor} from '../../../../actions/action-creators'
import {getEmailNotifyMsg, isNullOrEmpty} from '../../../../utils/strings.utils'
import InputPhone from '../../../../components/Inputs/InputPhone'
import SearchSelect from '../../../../components/Inputs/SearchSelect'
import {facturacionFormClienteAddError,facturacionFormClienteHandleChange} from '../../../../actions/facturacion/facturacionCliente.actions'
import * as datos from '../../../../initital-state/facturacion.state'
import ModalInfoCliente from './Modals/ModalInfoCliente'
import ModalConfirm from '../../../../components/Modals/Generales/ModalConfirm'
import InputChips from '../../../OtrosDocumentos/Components/InputChips'
import { generalOpenModalInfo } from '../../../../actions/general.actions'
import {Tooltip} from '../../../../components/Tooltip/Tooltip'

const DatosCliente = () => {
  const {fecha_actual} = useSelector((state: State) => state.general)
  const formCliente: ClienteF = useSelector((state: State) => state.facturacion.formCliente)
  const errors: ClienteF = useSelector((state: State) => state.facturacion.errorsFormCliente)
  const {tipoDocumento, departamentos, municipios, actividadesEconomicas} = useSelector((state: State) => state.catalogos)
  const modalInfo = useSelector((state: State) => state.facturacion.modals.activeInfoCliente)
  const loader = useSelector((state: State) => state.general.loader)

  const [camposReq, setCamposReq] = useState(datos.requeridosInicial)
  const [catalogoTipoDocumento, setCatalogoTipoDocumento] = useState(tipoDocumento)
  const [catalogueActividadEconomica, setCatalogueActividadEconomica] = useState(actividadesEconomicas.map((tipo) => ({...tipo,codigo_nombre: `${tipo.codigo} - ${tipo.valor}`})))
  const [modalServicios, setModalServicios] = useState({open: false, message: "", opcion: 0, tipoDoc: "0"});
  
  const dispatch = useDispatch()
  const acciones = bindActionCreators(actionFacturacionCliente, dispatch)
  const accionesProductos = bindActionCreators(actionFacturacionProducto, dispatch)
  const accionesClienteReceptor = bindActionCreators(actionsClienteReceptor, dispatch)
  const {getFechaHora} = bindActionCreators(actionGeneral, dispatch)
  
  useEffect(() => {
    getFechaHora()
    if(formCliente.checkContribuyente) {
      setCamposReq(datos.requeridosGranContribuyente)
      setCatalogoTipoDocumento(tipoDocumento.filter((tipo) => ((tipo.codigo === "36" || tipo.codigo === "13"))))
    } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (actividadesEconomicas.length > 0) setCatalogueActividadEconomica(actividadesEconomicas.map((tipo) => ({...tipo,codigo_nombre: `${tipo.codigo} - ${tipo.valor}`})))
  }, [actividadesEconomicas])

  useEffect(() => {
    if (tipoDocumento.length > 0 && !formCliente.checkContribuyente) setCatalogoTipoDocumento([{codigo: 'sinDocumento', valor: 'sin Documento'}, ...tipoDocumento])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tipoDocumento])

  useEffect(() => {
    if(formCliente.checkContribuyente || formCliente.checkCF) return;

    // Validacion 25000
    if(formCliente.validacionMonto25000) {
      setCamposReq(datos.requeridosValidacion25000);
      if (formCliente.tipoDocumento === "sinDocumento") {
        // Si selecciona sin documento, obligar a resetear campo
        acciones.facturacionFormClienteHandleChangeInput({target: {value: '', name: 'tipoDocumento'}})
      }
      return;
    }

    let nuevosRequeridos;
    switch (formCliente.tipoDocumento) {
      // *Sin Documento
      case 'sinDocumento':
        nuevosRequeridos = datos.requeridosSinDocumentoCF;
        break
      // *NIT, DUI
      case '36':
      case '13':
        nuevosRequeridos = datos.requeridoDuiNitCF;
        break
      // *OTRO, PASAPORTE, CARNET
      case '02':
      case '03':
      case '37':
        nuevosRequeridos = datos.requeridosOtrosCF;
        break
      default:
        nuevosRequeridos = datos.requeridosInicial;
        break
    }

    // Agregar validacion exento y ventas no sujetas (Si es exento o ventas no sujetas siempre pedir nombre independiente del doc)
if (formCliente.checkExentoImpuesto || formCliente.checkVentasNoSujetas) {
  setCamposReq({...nuevosRequeridos, nombre: true});
} else {
  setCamposReq(nuevosRequeridos);
}

  }, [formCliente])

  const handleChangeCheck = async (flag:boolean = false) => {
    if(!formCliente.checkCF && !flag ) {
      if(await accionesProductos.facturacionProductosVerificacionServicios()) return setModalServicios({open:true, message:"a consumidor final", opcion: 1, tipoDoc: "0"})
    }
    setCamposReq(formCliente.checkCF ? datos.requeridosInicial : datos.ningunoRequeridoCF)
    dispatch(facturacionFormClienteHandleChange({...datos.facturacionInitialState2.formCliente,checkCF: !formCliente.checkCF,}))
    setCatalogoTipoDocumento([{codigo: 'sinDocumento', valor: 'sin Documento'}, ...tipoDocumento])
    dispatch(facturacionFormClienteAddError(datos.facturacionInitialState2.errorsFormCliente))
    setModalServicios({open:false, message:"", opcion: 0, tipoDoc: "0"})
    dispatch(accionesProductos.facturacionDeleteServicios())
  }

  const handleChangeChekContribuyente = () => {
    if(!formCliente.checkContribuyente) {
      setCamposReq(datos.requeridosGranContribuyente)
      setCatalogoTipoDocumento(tipoDocumento.filter((tipo) => ((tipo.codigo === "36" || tipo.codigo === "13"))))
      if(formCliente.tipoDocumento !== "36" && formCliente.tipoDocumento !== "13") dispatch(facturacionFormClienteHandleChange({tipoDocumento: "", numId: "", nombreTipoDocumento:""}))
    } else {
      dispatch(facturacionFormClienteHandleChange({nrc: ""}))
      setCatalogoTipoDocumento([{codigo: 'sinDocumento', valor: 'sin Documento'}, ...tipoDocumento])
      setCamposReq(datos.requeridoDuiNitCF)
    }
    dispatch(facturacionFormClienteAddError(datos.facturacionInitialState2.errorsFormCliente))
    dispatch(facturacionFormClienteHandleChange({checkCF: false, checkContribuyente: !formCliente.checkContribuyente}))
  }
  
  const handleChangeCheckExento = () => {
    // Para exentos siempre pedir nombre cliente
    if (!formCliente.checkExentoImpuesto) setCamposReq(prevReq => ({...prevReq, nombre: true}));
    dispatch(facturacionFormClienteHandleChange({checkExentoImpuesto: !formCliente.checkExentoImpuesto}))

    // Si hay productos agregados, quitarles o agregarles el IVA
    accionesProductos.facturacionUpdateCalculosExentos();
  }

  const handleChangeCheckVentasNoSujetas = () => {
  // Para ventas no sujetas, también pedimos nombre obligatorio
  if (!formCliente.checkVentasNoSujetas) {
    setCamposReq(prevReq => ({...prevReq, nombre: true}));
  }
  dispatch(facturacionFormClienteHandleChange({
    checkVentasNoSujetas: !formCliente.checkVentasNoSujetas
  }));

  // Aplicar lógica similar a exentos pero para ventas no sujetas
  accionesProductos.facturacionUpdateCalculosVentasNoSujetas();
}


  const handleChangeCheckRetencion1 = () => {
    dispatch(facturacionFormClienteHandleChange({checkRetencion1: !formCliente.checkRetencion1}))
    accionesProductos.facturacionCalculoTotalArrayProducto();
  }

  const handleChangeCheckRetencionRenta = () => {
    dispatch(facturacionFormClienteHandleChange({checkRetencionRenta: !formCliente.checkRetencionRenta}))
    accionesProductos.facturacionCalculoTotalArrayProducto();
  }

    const handleChangeCheckPropina = () => {
    dispatch(facturacionFormClienteHandleChange({checkPropina: !formCliente.checkPropina}))
    accionesProductos.facturacionCalculoTotalArrayProducto();
  }

  const propinaActivaGlobal = useSelector((state: State) => state.userLogin.propina.propina_activa);
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) => {
    acciones.facturacionFormClienteHandleChangeInput(e)
    acciones.facturacionFormClienteOnBlur(e)
  }

  const onBlurClient = async (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>)  => {
    acciones.facturacionFormClienteOnBlur(e)
    if(formCliente.tipoDocumento && formCliente.numId) {

      const user:any = await accionesClienteReceptor.buscarClienteReceptor(formCliente)
      if(user !== null) {
        if (user?.notificarcorreo?.length > 0) { dispatch(generalOpenModalInfo(getEmailNotifyMsg(user.notificarcorreo))); }
        dispatch(acciones.facturacionInfoCliente(user))
        dispatch(acciones.facturacionOpenModalCliente())
      }
    }
  }

  const confirmarDatos = (data:any) => {
    dispatch(facturacionFormClienteHandleChange({...data, chipsEmail: data?.email?.split(','), email: ''}));
    dispatch(facturacionFormClienteAddError(datos.facturacionInitialState2.errorsFormCliente))
  }

  const handleTipoDocumento = async (value: any) => {
    if(value?.value === "sinDocumento" || value?.value === "37") {
      if(await accionesProductos.facturacionProductosVerificacionServicios()) return setModalServicios({open:true, message:`el tipo de documento a la opción ${value?.value === "37" ? "Otro": "Sin Documento"}`, opcion: 2, tipoDoc: value?.value})
    }
    acciones.facturacionFormClienteHandleChangeInput({target: {value: value?.value, name: 'tipoDocumento'},})
  }
  const confirmarEliminacionServiciosDoc = () => {
    dispatch(accionesProductos.facturacionDeleteServicios())
    acciones.facturacionFormClienteHandleChangeInput({target: {value: modalServicios.tipoDoc, name: 'tipoDocumento'},})
    setModalServicios({open:false, message:"", opcion: 0, tipoDoc: "0"})
  }

  return (
    <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec6-0b1e6fa6' className='w-layout-cell'>
      {modalInfo && <ModalInfoCliente confirmarDatos={(datos:any) => confirmarDatos(datos)} noNRC={!formCliente.checkContribuyente} />}
      {modalServicios.open && 
        <ModalConfirm Styles={{maxWidth: "500px"}} title={'Eliminación de Servicios'}
          detail={`Para cambiar ${modalServicios.message}, el cual NO permite tener servicios incluidos, se procederá a la eliminación de los servicios agregados, ¿Estás seguro que deseas cambiar ${modalServicios.message}?`} messageAction='Sí' messageClose='No'
          actionConfirm={() => modalServicios.opcion === 1 ? handleChangeCheck(true) : confirmarEliminacionServiciosDoc()}
          closeModalConfirm={() => setModalServicios({open:false, message:"", opcion: 0, tipoDoc: "0"})}
        />}
      <div className='card w-form'>
        <form className='form-content' data-wf-page-id='64b58c72be2b65200b1e6fa6' data-wf-element-id='deb0f47f-468f-13fc-f1eb-4d36c39616dc'>
          <div>
            <h3 className='card-title l'>Cálculos de DTE</h3>
          </div>
          <div className='form-separator'></div>

          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label className='container-checkbox m'>
                <Tooltip content='No paga IVA por ley o exoneración'>
                  Exento de impuesto
                </Tooltip>
                <input autoFocus type='checkbox' name='checkCF' checked={formCliente.checkExentoImpuesto} onChange={() => handleChangeCheckExento()} disabled={formCliente.checkCF}/>
                <span className='checkmark-checkbox'></span>
              </label>
            </div>
            <div className='label-input'>
              <label className='container-checkbox m'>
                <Tooltip content='Aplica retención del 1% en ventas'>
                  Retención 1%
                </Tooltip>
                <input type='checkbox' name='checkGob' checked={formCliente.checkRetencion1} onChange={() => handleChangeCheckRetencion1()} disabled={formCliente.checkCF}/>
                <span className='checkmark-checkbox'></span>
              </label>
            </div>
          </div>
          {/* se comento por cambios de Hacienda art 145 codigo tributario  */}
          {/* <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label className='container-checkbox m'>
                <Tooltip content='Retiene el 10 % sobre servicios agregados'>
                  Retención Renta 10%
                </Tooltip>
                <input type='checkbox' name='checkReteRenta' checked={formCliente.checkRetencionRenta} onChange={() => handleChangeCheckRetencionRenta()} disabled={formCliente.checkCF || formCliente.checkExentoImpuesto}/>
                <span className='checkmark-checkbox'></span>
              </label>
              
            </div>
          </div> */}
          <div className='label-input'>
            <label className='container-checkbox m'>
              <Tooltip content='Monto no sujeto al cálculo del 13% de IVA según normativa legal'>
                  Ventas no sujetas
              </Tooltip>
              <input type='checkbox' name='checkVentasNoSujetas' checked={formCliente.checkVentasNoSujetas} onChange={() => handleChangeCheckVentasNoSujetas()} disabled={formCliente.checkCF}/>
              <span className='checkmark-checkbox'></span>
            </label>
          </div>
          {propinaActivaGlobal && (
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label className='container-checkbox m'>
                <Tooltip content='activa para aplicar la propina'>
                  Propina
                </Tooltip>
                <input type='checkbox' name='checkPropina' checked={formCliente.checkPropina} onChange={() => handleChangeCheckPropina()} disabled={formCliente.checkRetencion1 || formCliente.checkExentoImpuesto}/>
                <span className='checkmark-checkbox'></span>
              </label>
            </div>
          </div>
          )}

          <div>
            <h3 className='card-title l'>Datos del Cliente</h3>
          </div>
          <div className='form-separator'></div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label className='container-checkbox m'>
                <Tooltip content='Sin detalle de receptor, solo nombre '>
                  Al consumidor final
                </Tooltip>
                <input autoFocus type='checkbox' name='checkCF' checked={formCliente.checkCF} onChange={() => handleChangeCheck(false)}/>
                <span className='checkmark-checkbox'></span>
              </label>
            </div>
            <div className='label-input'>
              <label className='container-checkbox m'>
                <Tooltip content='Identifica al receptor como gran contribuyente'>
                  Gran contribuyente
                </Tooltip>
                <input type='checkbox' name='checkContribuyente' checked={formCliente.checkContribuyente} onChange={handleChangeChekContribuyente} disabled={tipoDocumento.length === 0}/>
                <span className='checkmark-checkbox'></span>
              </label>
            </div>
          </div>
          
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='fecha' className='field-label m'>
                Fecha de factura
              </label>
              <input
                autoComplete='off'
                type='date'
                className='m text-field w-input'
                name='fecha'
                data-name=''
                id='fecha'
                min='2000-01-01'
                value={fecha_actual?.FechaInput || formCliente.fecha}
                disabled={true}
                onChange={handleChange}
                onBlur={acciones.facturacionFormClienteOnBlur}
              />
              {errors.fecha && <p className='alert s'>{errors.fecha}</p>}
            </div>
            <div className='label-input'>
              <label htmlFor='tipoDocumento' className='field-label m'>
                Tipo de documento de identificación{camposReq.tipoDocumento && <span style={{color: 'red'}}>*</span>}
              </label>
              <SearchSelect
              defaultValue={null}
                disabled={formCliente.checkCF ? true : false}
                placeholder='Tipo de Identificación'
                value={formCliente.tipoDocumento}
                name='tipoDocumento'
                data={catalogoTipoDocumento}
                keyNameText='valor'
                keyNameValue='codigo'
                onChange={(value: any) => {handleTipoDocumento(value)}}
              />
              {errors.tipoDocumento && <p className='alert s'>{errors.tipoDocumento}</p>}
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='numId' className='field-label m'>
                {formCliente.nombreTipoDocumento || 'Número de identificación'}{camposReq.numId && <span style={{color: 'red'}}>*</span>}
              </label>
              <input
                autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='numId'
                data-name='numId'
                placeholder={`Número de ${formCliente.nombreTipoDocumento || 'Identificación'}`}
                id='numId'
                disabled={loader ? true : formCliente.tipoDocumento ? formCliente.tipoDocumento === 'sinDocumento' ? true : false : true }
                maxLength={20}
                value={formCliente.numId}
                onChange={handleChange}
                onBlur={onBlurClient}
              />
              {errors.numId && <p className='alert s'>{errors.numId}</p>}
            </div>
            <div className='label-input'></div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='nombre' className='field-label m'>
                Nombre del cliente{camposReq.nombre && <span style={{color: 'red'}}>*</span>}
              </label>
              <input
                autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='nombre'
                data-name=''
                placeholder='Nombre del cliente'
                id='nombre'
                disabled={(formCliente.tipoDocumento || formCliente.checkCF || formCliente.checkExentoImpuesto || formCliente.checkVentasNoSujetas) ? false : true}
                maxLength={250}
                value={formCliente.nombre}
                onChange={handleChange}
                onBlur={acciones.facturacionFormClienteOnBlur}
              />
              {errors.nombre && <p className='alert s'>{errors.nombre}</p>}
            </div>
            <div className='label-input'>
              <label htmlFor='departamento' className='field-label m'>
                Departamento{camposReq.departamento && <span style={{color: 'red'}}>*</span>}
              </label>
              <SearchSelect
              defaultValue={null}
                disabled={loader ? true : formCliente.tipoDocumento ? false : true}
                placeholder='Actividad económica'
                value={formCliente.departamento}
                name='actividad'
                data={departamentos?.map((dep) => ({...dep, codigo_nombre: `${dep.codigo} - ${dep.valor}`}))}
                keyNameText='codigo_nombre'
                keyNameValue='codigo'
                onChange={(value: any) => {
                  acciones.facturacionFormClienteHandleChangeInput({target: {value: value?.value, name: 'departamento'},})
                  acciones.facturacionFormClienteOnBlur({target: {value: value?.value, name: 'departamento'},})
                }}
              />
              {errors.departamento && <p className='alert s'>{errors.departamento}</p>}
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='municipio' className='field-label m'>
                Municipio{camposReq.municipio && <span style={{color: 'red'}}>*</span>}
              </label>
              <SearchSelect
              defaultValue={null}
                disabled={isNullOrEmpty(formCliente.departamento)? true : formCliente.tipoDocumento ? false : true}
                placeholder='Actividad económica'
                value={formCliente.municipio}
                name='municipio'
                data={municipios?.map((mun) => ({...mun, codigo_nombre: `${mun?.codigo} - ${mun?.valor}`}))}
                keyNameText='codigo_nombre'
                keyNameValue='codigo'
                onChange={(value: any) => {
                  acciones.facturacionFormClienteHandleChangeInput({target: {value: value?.value, name: 'municipio'},})
                }}
              />
              {errors.municipio && <p className='alert s'>{errors.municipio}</p>}
            </div>
            <div className='label-input'>
              <label htmlFor='direccion' className='field-label m'>
                Dirección{camposReq.direccion && <span style={{color: 'red'}}>*</span>}
              </label>
              <input
                autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='direccion'
                data-name=''
                placeholder='Dirección'
                id='direccion'
                disabled={isNullOrEmpty(formCliente.municipio)? true : formCliente.tipoDocumento ? false : true}
                maxLength={200}
                value={formCliente.direccion}
                onChange={handleChange}
                onBlur={acciones.facturacionFormClienteOnBlur}
              />
              {errors.direccion && <p className='alert s'>{errors.direccion}</p>}
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <InputChips 
              maxChips={5} chips={formCliente.chipsEmail} setChips={(chipsEmail: Array<string>) => acciones.facturacionFormClienteHandleChangeInput({target: {value: chipsEmail, name: 'chipsEmail'}})} 
              maxLength={100} onBlur={acciones.facturacionFormClienteOnBlur} required={camposReq.email} name='email' placeholder='Correo electrónico' 
              label = 'Correo electrónico' type='email' value={formCliente.email} error={errors.email} onChange={handleChange}
              disabled={formCliente.tipoDocumento ? false : true}
            />
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='telefono' className='field-label m'>
                Teléfono celular{camposReq.telefono && <span style={{color: 'red'}}>*</span>}
              </label>
              <InputPhone
                disabled={formCliente.tipoDocumento ? false : true}
                value={formCliente.telefono}
                onChange={acciones.facturacionFormClienteHandleChangeInputPhone}
                onBlur={acciones.facturacionFormClienteOnBlur}
                className='telefono-style'
                name='telefono'
              />
              {errors.telefono && <p className='alert s'>{errors.telefono}</p>}
            </div>
            <div className='label-input'>
              <label htmlFor='actividad' className='field-label m'>
                Actividad{camposReq.actividad && <span style={{color: 'red'}}></span>}
              </label>
              <SearchSelect
              defaultValue={null}
                disabled={formCliente.tipoDocumento ? false : true}
                placeholder='Actividad económica'
                value={formCliente.actividad}
                name='actividad'
                data={catalogueActividadEconomica}
                keyNameText='codigo_nombre'
                keyNameValue='codigo'
                onChange={(value: any) => {
                  acciones.facturacionFormClienteHandleChangeInput({target: {value: value?.value, name: 'actividad'},})
                  acciones.facturacionFormClienteOnBlur({target: {value: value?.value, name: 'actividad'},})
                }}
              />
              {errors.actividad && <p className='alert s'>{errors.actividad}</p>}
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            {formCliente.checkContribuyente && <div className='label-input'>
              <label htmlFor='nrc' className='field-label m'>NRC<span style={{color: 'red'}}></span></label>
              <input autoComplete='off' type='text' className='m text-field w-input' name='nrc' data-name='nrc' placeholder="NRC" id='nrc'
                maxLength={7} value={formCliente.nrc} onChange={handleChange} onBlur={acciones.facturacionFormClienteOnBlur} />
              {errors.nrc && <p className='alert s'>{errors.nrc}</p>}
            </div>}
            <div className='label-input'></div>
          </div>
        </form>
      </div>
    </div>
  )
}

export default DatosCliente
